import Axios from 'axios'
const p = (path = '') => `${window.$ApiHost}/reports/${path ? path + '/' : path}`

const state = {
  items: [],
  isHave: true,
  totalPages: 0,
}

const mutations = {
  SET_ITEMS(state, { totalItems, results, totalPages }) {
    results.forEach(el => (el.user_role = el.user_role === 1 ? 'Lender' : el.user_role === 2 ? 'Renter' : ''))
    state.items = results
    state.isHave = state.items.length < totalItems
    state.totalPages = totalPages
  },
}

const actions = {
  async getItems({ commit }, params) {
    let response
    try {
      response = await Axios(p(), { params })
      commit('SET_ITEMS', { ...response.data, totalItems: response.data.total_objects, totalPages: response.data.total_pages })
    } catch (error) {
      response = error.response
    }
    return response
  },
  // eslint-disable-next-line camelcase
  async getSvcReports(_, { reports_id = [] }) {
    let response
    try {
      response = await Axios.post(p('export'), { reports_id })

      const blob = new Blob([response.data])
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `reports-${new Date()}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    } catch (error) {
      response = error?.response
    }
    return response
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
